// ItemMaster Digital Content Alert
export const imDropboxContentLink = "https://www.dropbox.com/sh/w935vwjk7oeml5y/AAAoV-VBNmFTEGjzVTv1YZVta?dl=0";
export const imDropboxContentLinkText = "Dropbox";
export const sampleProductText = "This is a sample product.";
